import { isArray } from "lodash";

import { IDropdownOption } from "@treelab/panda";

import { ColumnType, ITableColumn, ITypeOptions } from "../types/table-type";
import { FilterType, FilterCondition, IFilterMeta, IFilterValue, OperatorType } from "../types/form-type";

import {
  CONDITION_OPTIONS,
  getFinalColumnType,
  FILTERSTRING_IS_ARRAY_ONE_BY_FILTERCONDITION,
} from "./filter_secondary";
import { formatMessageForList } from "../lib/intl";

export const FILTER_TYPE_MAP: { [key in ColumnType]: FilterType } = {
  [ColumnType.TEXT]: FilterType.TEXT,
  [ColumnType.PHONE]: FilterType.PHONE,
  [ColumnType.EMAIL]: FilterType.EMAIL,
  [ColumnType.LONG_TEXT]: FilterType.TEXT,
  [ColumnType.UNIQUE_ID]: FilterType.TEXT,
  [ColumnType.NUMBER]: FilterType.NUMBER,
  [ColumnType.RECORD_REFERENCE]: FilterType.TEXT,
  [ColumnType.DATETIME]: FilterType.DATE,
  [ColumnType.STATUS]: FilterType.STATUS,
  [ColumnType.SELECT]: FilterType.SELECT,
  [ColumnType.MULTI_SELECT]: FilterType.MULTI_SELECT,
  [ColumnType.MULTI_ATTACHMENT]: FilterType.ATTACHMENT,
  [ColumnType.LOOKUP]: FilterType.LOOKUP,
  [ColumnType.RATING]: FilterType.NUMBER,
  [ColumnType.CHECKBOX]: FilterType.CHECKBOX,
  [ColumnType.ROLLUP]: FilterType.TEXT,
  [ColumnType.NOOP]: FilterType.TEXT,
  [ColumnType.FORMULA]: FilterType.TEXT,
  [ColumnType.CURRENCY]: FilterType.NUMBER,
  [ColumnType.COLLABORATOR]: FilterType.COLLABORATOR,
  [ColumnType.AUTO_NUMBER]: FilterType.NUMBER,
  [ColumnType.CREATED_AT]: FilterType.DATE,
  [ColumnType.CREATED_BY]: FilterType.CREATED_BY,
};

// columnType =>  FilterType  基于实际值 而非 原始值
export const getDefaultFilterValue = (columns: ITableColumn[]): IFilterMeta => {
  const firstCol = columns[0];
  if (!firstCol) return { operatorType: OperatorType.AND, filterValues: [] };
  const filterMeta = {
    operatorType: OperatorType.AND,
    filterValues: [],
  };
  return filterMeta;
};

export const getDefaultFilterItemValue = (columns: ITableColumn[]): IFilterValue => {
  const firstCol = columns[0];
  if (!firstCol) return { columnId: "", filterType: FilterType.TEXT, filterCondition: FilterCondition.IS_EMPTY };
  const conditions = getConditionOptions(firstCol);
  const filterValue = {
    columnId: firstCol.id,
    filterType: FILTER_TYPE_MAP[firstCol.type],
    filterCondition: conditions[0].value as FilterCondition,
  };
  return filterValue;
};

/**
 * 根据 column 计算 condition
 * @param column
 * @returns
 */
export const getConditionOptions = (column: ITableColumn | undefined): IDropdownOption[] => {
  if (!column) return [];

  const typeOptions = { ...column.typeOptions, type: column.type };
  const type = getFinalColumnType(typeOptions as ITypeOptions, true);
  const list = (column && CONDITION_OPTIONS[FILTER_TYPE_MAP[type]]) || [];
  const options = formatMessageForList(list, "name") as unknown[];
  return options as IDropdownOption[];
};

/**
 * condition 改变后，生成新的 filterValue
 * @param oldValue
 * @param newCondition
 */
export const convertFilterValueByCondition = (oldValue: IFilterValue, newCondition: FilterCondition): IFilterValue => {
  const newValue = {
    ...oldValue,
    filterCondition: newCondition,
  };

  if (
    FILTERSTRING_IS_ARRAY_ONE_BY_FILTERCONDITION[newCondition] &&
    isArray(newValue.filterString) &&
    newValue.filterString.length > 1
  ) {
    newValue.filterString = [newValue.filterString[0]];
  }

  return newValue;
};
